.g5{border:1px solid #ddd;}